import axios from "axios";

const api = axios.create({
  baseURL: 'https://agendamentoplanetario20210722180630.azurewebsites.net/'
  // baseURL: 'https://localhost:5001/'
});



api.interceptors.request.use(async config =>{
  const token = getToken();
  if(token){
    config.headers.Authorization = `Bearer ${token}`
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    // const access_token = getToken();
    if (error.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);

export const TOKEN_KEY = "@token-session";
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const login = (token:string) => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const logout = () => {
  console.log('efetuando logout...');
  localStorage.removeItem(TOKEN_KEY);
  window.location.href = '/Login';
}
export default api;